module.exports = __webpack_public_path__ + "static/media/LogoCsea.1d904be2.png";